import { useEffect, useState } from 'react';
import { Box, Stack, TextField, Typography } from '@mui/material';

import { PatientTimelineView } from './components/patient-timeline';

const STORAGE_KEY = 'patientTimelineTestPage:patientId';

/**
 * Dev-only sandbox at `/timeline`. Mounts the unified timeline view
 * against an arbitrary patient_id so we can smoke-test the envelope
 * rendering, threading, drop zone, and SSE-driven refetches end-to-end
 * before / without going through the patient-page container.
 */
export function PatientTimelineTestPage() {
  const [patientId, setPatientId] = useState<string>(
    () => localStorage.getItem(STORAGE_KEY) ?? '',
  );

  useEffect(() => {
    if (patientId) {
      localStorage.setItem(STORAGE_KEY, patientId);
    }
  }, [patientId]);

  return (
    <Box sx={{ maxWidth: 960, mx: 'auto', py: 3, px: 2 }}>
      <Stack spacing={2}>
        <Box>
          <Typography variant="h5" gutterBottom>
            Patient timeline — sandbox
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Drop, paste, or upload files anywhere on the page. DocRef cards
            populate live as the backend pipeline progresses (artifact SSE
            drives coarse cache invalidation for v1).
          </Typography>
        </Box>

        <TextField
          label="patient_id"
          value={patientId}
          onChange={(e) => setPatientId(e.target.value.trim())}
          size="small"
          fullWidth
          placeholder="paste a patient UUID"
          helperText="Persisted to localStorage; any patient in your org works."
        />

        {patientId ? (
          <PatientTimelineView patientId={patientId} />
        ) : (
          <Typography variant="body2" color="text.secondary">
            Enter a patient_id above to mount the timeline.
          </Typography>
        )}
      </Stack>
    </Box>
  );
}
